import { alchemyLight } from "./color-schemes";
export const NAMESPACE = "aui";
export const BASE_UNIT = 8;
export const SHADOW_COLOR = "rgba(0,0,0,0.25)";
export const SHADOW_DEPTHS = {
    default: `0 2px 4px ${SHADOW_COLOR}`,
    base: `0 2px 4px ${SHADOW_COLOR}`,
    card: `0px 2px 12px rgba(0,0,0,0.10)`,
    cardHover: `0px 6px 20px rgba(0,0,0,0.15)`,
    centered: `0 0 4px ${SHADOW_COLOR}`,
    tooltip: `0 6px 8px 0 ${SHADOW_COLOR}`,
    dialog: `0 8px 25px 0 ${SHADOW_COLOR}`,
    menu: `0 2px 4px 0 rgba(0,0,0,0.08), 0 6px 18px 0 rgba(0,0,0,0.18)`,
    moduleChrome: `0 2px 12px 0 rgba(0,0,0,0.10)`
};
export const BORDERS = {
    // TODO: This can't be a constant like this, it should pull from theme
    default: `1px solid ${alchemyLight.structural.line}`
};
export const BORDER_RADII = {
    /** This is the default that should be used most often */
    default: "3px",
    small: "2px",
    medium: "3px",
    large: "6px",
    extraLarge: "16px",
    extraExtraLarge: "18px",
    full: "100vh"
};
export const BUTTON_BORDER_RADII = {
    default: "34px",
    extraSmall: "14px",
    small: "26px",
    medium: "34px",
    large: "44px"
};
export const TRANSITION_TYPES = {
    base: "base",
    ease: "ease",
    slow: "slow",
    slowEase: "slowEase"
};
export const TRANSITION_TIMING = {
    base: "cubic-bezier(0.75, -0.15, 0.35, 1.15)",
    ease: "ease-in-out"
};
export const TRANSITION_DURATION = {
    base: 200,
    slow: 600
};
export const BREAKPOINTS = {
    small: 281,
    medium: 601,
    large: 1101
};
